<template>
  <div class="loading"></div>
</template>

<script>
import Auth from "@/util/auth.js";

export default {
  mounted() {
    this.getAuthInfo();
  },
  methods: {
    /**
     * 检查身份信息
     */
    getAuthInfo() {
      var me = this,
        token = me.$route.query.token,
        page = me.$route.query.page;
      if (token) {
        // 有传jwt token过来
        me.getAuthInfoByToken(token, page);
      } else {
        // 否则，判断当前页面是否有登录信息。未登录则跳转登录
        Auth.get()
          .then(function (info) {
            if (page && page.indexOf('https') == 0) {
              window.location.href = page;
            } else {
              me.$router.replace(page || ("/" + info.appId.replace("-app", "")));
            }
          })
          .catch(() => {
            me.$router.replace({
              name: 'Login',
              query: {
                page
              }
            });
          });
      }
    },
    /**
     * 使用jwt token检查身份信息
     */
    getAuthInfoByToken(token, page) {
      var me = this, crossDomain = page && page.indexOf('https') == 0 ? true : false;
      me.$ajax({
        url: "/api/auth/info",
        headers: {
          Authorization: token,
        },
        withCredentials: true,
        params: {
          crossDomain
        }
      }).then(function (res) {
        if (res.success) {
          var authData = res.data;
          Auth.set(authData);
          if (crossDomain) {
            window.location.href = page;
          } else {
            me.$router.replace(page || ("/" + authData.appId.replace("-app", "")));
          }
        } else {
          me.$weui.topTips(res.message, 3000);
          me.$router.replace({
            name: 'Login',
            query: {
              page
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -80px 0 0 -40px;
  width: 80px;
  height: 80px;
  border: 3px solid #d0d3d4;
  border-top-color: #626567;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>